<script>
import api from '../../helpers/apirest/api';
import Vue from "vue";

/**
 * Advanced table component
 */
export default {
  components: {  },
  emits:['edit', 'changeStatus'],
  props:{
        url:String,
        containerTableClass:String,
        fields:{
            type:Array,
            default() {
                return []
            }
        },
        showEdit:{
            type: Boolean,
            default: true
        },
        showView:{
            type: Boolean,
            default: false
        },
        showChangeStatus:{
            type: Boolean,
            default: true
        },
        showDelete:{
            type: Boolean,
            default: false
        },
        showActions:{
            type: Boolean,
            default: true
        },
        showAutoRefresh:{
            type: Boolean,
            default: false
        },
        params:{
            type: Object,
            default() {
                return {};
            }
        },
        formatter:{
            type: Function,  
            default: () => {}          
        },
        formattedFields:{
            type:Array,
            default() {
                return []
            }
        }
    },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [ 10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      isBusy: false,
      tableFields: [
          ...this.fields,
          (this.showActions) ? { key: "actions", sortable: false, tdClass: "custom-table-action" } : null
      ],
      autorefresh:false,
      refreshSeconds:5,
      interval:null
    };
  },
  methods: {

    async loadData(ctx) {
        try {

            let sort = null;
            if(ctx?.sortBy != ''){
                sort = (ctx?.sortDesc) ? 'desc' : 'asc';
            }
            
            const response = await api.get({
                url:this.url,
                params:{
                    ...this.params,
                    page: ctx?.currentPage,
                    per_page: ctx?.perPage,
                    filter: ctx?.filter || null,
                    sort_by: ctx?.sortBy || null,
                    sort: sort,
                }
            });

            const data = response?.data?.data;
            const meta = response?.data?.meta;

            this.totalRows = meta?.total;

            return data;
        } catch (error) {
            return []
        }
    },
    edit(row) {        
        this.$emit("edit", row?.item);
    },
    show(row) {        
        this.$emit("show", row?.item);
    },
    refresh(){
        this.$refs.table.refresh();
    },
    async changeStatus(item){
        await api.patch({
            url:`${this.url}/${item?.id}/change-status`
        });

        this.refresh();
    },
    async deleteRow(item){
        try {

            await Vue.swal({
            title: "Delete this row?",
            icon: "info",
            html:  "Are you sure you want to delete this record?",
            showCloseButton: false,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return api.delete({
                    url: `${this.url}`,
                    id: item?.id
                }).then(()=>{
                    this.refresh();
                });
            },
            });
            
        }
        catch (error) {
            console.log(error);
        }
    },
    changeAutoRefresh(){

        if(this.interval){
            clearInterval(this.interval);
        }

        if(this.autorefresh){
            const self = this;
            const time = (this.refreshSeconds * 1000);
            this.interval = setInterval(function() {
                console.log(self.refreshSeconds)
                self.refresh();
            }, time);
        }        
    }
  },
  watch:{
    refreshSeconds(){
        this.changeAutoRefresh();
    }
  }
};
</script>

<template>
    <div>
        <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                Show&nbsp;
                <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                </label>
            </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
            <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                <label class="d-inline-flex align-items-center">
                Search:
                <b-form-input
                    debounce="500"
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                ></b-form-input>
                </label>
            </div>
            </div>
            <!-- End search -->
        </div>
        <!-- Table -->
        <div class="table-responsive mb-0 custom-table" :class="containerTableClass">
            <b-table
            ref="table"
            :items="loadData"
            :fields="tableFields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :busy.sync="isBusy"
            :filter="filter"
            >

            <template v-for="(column, index) in formattedFields" v-slot:[`cell(${column})`]="{ item }">
            <span v-html="formatter(column, item)" :key="index"></span>
            </template>
        
            <template #cell(actions)="row" v-if="showActions">
                <div>
                    <slot name="before-custom-actions" v-bind:row="row"></slot>

                    <a
                        href="javascript:void(0);"
                        class="mr-3 text-primary"
                        v-b-tooltip.hover
                        title="View detail"
                        v-if="showView"
                        @click="show(row)"
                    >
                        <i class="ri-eye-fill font-size-18"></i>
                    </a>
                    
                    <a
                        href="javascript:void(0);"
                        class="mr-3 text-primary"
                        v-b-tooltip.hover
                        title="Edit"
                        v-if="showEdit"
                        @click="edit(row)"
                    >
                        <i class="mdi mdi-pencil font-size-18"></i>
                    </a>

                    <b-form-checkbox
                        v-if="showChangeStatus"
                        v-model="row.item.status"
                        switch class="mb-1"
                        value="1"
                        @change="changeStatus(row.item)"
                    ></b-form-checkbox>

                    <slot name="after-custom-actions" v-bind:row="row"></slot>

                    
                    <a
                        v-if="showDelete"
                        href="javascript:void(0);"
                        class="text-danger"
                        v-b-tooltip.hover
                        title="Delete"
                        @click="deleteRow(row.item)"
                    >
                        <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                </div>                
            </template>
        
            </b-table>
            <div v-if="isBusy" class="text-center text-primary my-2 table-spinner">
                <b-spinner class="align-middle"></b-spinner>
            </div> 
        </div>
        <div class="row">
            <div class="col mt-2">
                <div class="float-left autorefresh" v-if="showAutoRefresh">
                    <span class="mr-1">Autorefresh </span>
                    <b-form-checkbox
                        v-model="autorefresh"
                        switch class="mb-1"
                        value="1"
                        @change="changeAutoRefresh()"
                    ></b-form-checkbox>
                    <b-form-input
                        debounce="500"
                        v-if="autorefresh"
                        v-model="refreshSeconds"
                        type="number"
                        placeholder=""
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                </div>
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>